import { render, staticRenderFns } from "./SocialLoginRedrictPage.vue?vue&type=template&id=373f87ca&"
import script from "./SocialLoginRedrictPage.vue?vue&type=script&lang=js&"
export * from "./SocialLoginRedrictPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports